module.exports = __webpack_public_path__ + "static/media/chess-knight.538a68a2.svg";